import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const RedirectHandler = ({ component }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirectTo = params.get("redirect");
    const course = params.get("course");
    const hostname = window.location.hostname;

    // Check if course is explicitly set in URL or if domain is ksolgcse.co.uk
    if (course === "gcse" || hostname.includes("ksolgcse.co.uk")) {
      localStorage.setItem("gcse", "true");
    }

    if (redirectTo) {
      navigate(`/${redirectTo}`, { replace: true });
    } else {
      setReady(true);
    }
  }, [location.search, navigate]);

  return ready ? component : null;
};

export default RedirectHandler;
